module.exports = __webpack_public_path__ + "img/thumb-wortels-met-tijm.0cd2bad4.jpeg";